import React from "react";
import { EncodingType } from "../../redux/api/api.types";
import { InstanceEncodingDTO } from "./types";
import InstanceEncodingRow from "./InstanceEncodingRow";

export default function InstanceEncodingTable (data: EncodingType[]) {
  const renderEncodings = (data: EncodingType[]) => {
    const encodingRows: InstanceEncodingDTO[] = []
    // eslint-disable-next-line react/destructuring-assignment
    data.forEach(({method, metadata}) => {
      if (metadata && Object.keys(metadata).length > 0) {
        let index = 0;
        Object.entries(metadata).forEach(([key, value]) => {
          if (index === 0) {
            encodingRows.push(
              {
                method,
                metadataKey: key,
                metadataValue: value.toString(),
              }
            )
          } else {
            encodingRows.push(
              {
                method: "-",
                metadataKey: key,
                metadataValue: value.toString(),
              }
            )
          }
          index += 1;
        });
      } else {
        encodingRows.push({
          method,
          metadataKey: "-",
          metadataValue: "-",
        })
      };
    });

    if (encodingRows.length > 0) {
      return encodingRows.map((entry) => InstanceEncodingRow(entry));
    }

    return InstanceEncodingRow({
      method: "-",
      metadataKey: "-",
      metadataValue: "-",
    })
  }
  return (
    <>
      {InstanceEncodingRow({
        method: "Encoding Method",
        metadataKey: "Parameter Key",
        metadataValue: "Parameter Value",
      }, true)}
      {renderEncodings(data)}
    </>
  )
}